<app-main>
  <h1>Incidents</h1>
  <div
    style="margin-bottom: 16px; display: flex; justify-content: space-between"
  >
    <app-generic-search-label
      [listElements]="listIncident"
      [tableConfig]="tableConfig"
      endPoint="incident"
      (queryEmit)="search($event)"
    ></app-generic-search-label>
  </div>
  <app-generic-table
    [config]="tableConfig"
    [rows]="listIncident"
    [pageInformations]="pageInformations"
    (pageEmit)="pageEvent($event)"
    [detailsbutton]="true"
    (detailsEmit)="openDetails($event)"
    [affranchibutton]="true"
    (affranchiEmit)="createAffranchi($event)"
    [isClickable]="true"
    [emitClickRow]="emitClickRow"
  ></app-generic-table>
</app-main>
